export const Types = {
    OFF: 'loading/OFF',
    ON: 'loading/ON',
  };

const initialState = { 
    type: Types.OFF,
    loading: false,
};

export default function loadingReducer (state = initialState, action) {
    switch (action.type) {
        case Types.ON:
            return {
                ...state,
                ...action
            };
            case Types.OFF:
                return {
                    ...state,
                    ...action
                };
        default:
            return state;
    }
};

export function startLoadingAnimate() {
    return {
        type: Types.ON,
        loading: true,
    }
}

export function stopLoadingAnimate() {
    return {
        type: Types.OFF,
        loading: false,
    }
}